var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comments"},[_c('h3',{staticClass:"text-center"},[_vm._v("Comments")]),(_vm.lastUpdateTime)?_c('h5',{staticClass:"last-updated-time"},[_vm._v(" Last updated: "+_vm._s(_vm.lastUpdateTime)+" ")]):_vm._e(),_c('v-textarea',{staticClass:"comments-box",attrs:{"value":_vm.value,"counter":"1000","rules":[
      (v) =>
        (v || '').length <= 1000 || 'Comment must be 1000 characters or less',
    ]},on:{"input":(value) => _vm.$emit('input', value.slice(0, 1000))}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }